export default __webpack_public_path__ + "locales/nl/Webhooks.json?hash=f1884aed01f85dfbc17708d4721d03d6";